 import '@stoplight/elements-dev-portal/styles.min.css';
import { DevPortalProvider } from '@stoplight/elements-dev-portal';
import React, { Component } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { NotFound } from './components/NotFound';
import { StoplightProjectDocs } from './components/StoplightProject';

//Jake: This project is not compatible with React 18 and so running this within the monorepo will cause conflicts with newer Type definitions. 
//For this reason, to run this project, remove the api-docs folder from the monorepo and run npm start.
class App extends Component {
  render() {
    return (
      <DevPortalProvider>
        <BrowserRouter>
          <div className="app-container">
            <header>
              <Navigation />
            </header>
            <main className="main-content">
              <Switch>
                <Route exact path="/">
                  <Redirect to="/APIDOCS_V2" />
                </Route>
                <Route path="/APIDOCS_V2" component={StoplightProjectDocs} />
                <Route component={NotFound} />
              </Switch>
            </main>
          </div>
        </BrowserRouter>
      </DevPortalProvider>
    );
  }
}
export default App;